export type ElementTypes = 'primary' | 'secondary' | 'success' | 'warning' | 'alert' | 'info'

export const elementTypeIsValid = (type: string): type is ElementTypes => {
  return ['primary', 'secondary', 'success', 'warning', 'alert', 'info'].includes(type)
}
